import { AccountStatusSmartEnum } from "./AccountStatusSmartEnum";
import { BackgroundTaskStatusSmartEnum } from "./BackgroundTaskStatusSmartEnum";
import { FoundStatusSmartEnum } from "./FoundStatusSmartEnum";
import { RecallLineItemStatusSmartEnum } from "./RecallLineItemStatusSmartEnum";
import { RecallStatusSmartEnum } from "./RecallStatusSmartEnum";
import { CaseMaterialStatusSmartEnum } from "./CaseMaterialStatusSmartEnum";
import { CustomerStatusSmartEnum } from "./CustomerStatusSmartEnum";
import { OuterCubeStatusSmartEnum } from "./OuterCubeStatusSmartEnum";
import { RangeStatusSmartEnum } from "./RangeStatusSmartEnum";
import { SpecimenStatusSmartEnum } from "./SpecimenStatusSmartEnum";
import { UserStatusSmartEnum } from "./UserStatusSmartEnum";
import { OperatorStatusSmartEnum } from "./OperatorStatusSmartEnum";
import { PackingBoxStatusSmartEnum } from "./PackingBoxStatusSmartEnum";
import { isStatusDto, Status, StatusDto } from "./Status";
import { UpliftStatusSmartEnum } from "./UpliftStatusSmartEnum";
import { ReturnsStatusSmartEnum } from "./ReturnsStatusSmartEnum";
import { ReturnLineItemStatusSmartEnum } from "./ReturnLineItemStatusSmartEnum";
import { InvoiceTypeSmartEnum } from "./InvoiceTypeSmartEnum";
import { OuterCubeTypeSmartEnum } from "./OuterCubeTypeSmartEnum";
import { UserPermissionsLevelSmartEnum } from "./UserPermissionsLevelSmartEnum";
import { OperatorPermissionsLevelSmartEnum } from "./OperatorPermissionsLevelSmartEnum";
import { DisposalStatusSmartEnum } from "./DisposalStatusSmartEnum";
import { IPillLookup } from "../../components/app/Pill";
import { DisposalLineItemStatusSmartEnum } from "./DisposalLineItemStatusSmartEnum";
import { OrderNumberTypeSmartEnum } from "./OrderNumberTypeSmartEnum";

export const statusLookup: { [key: string]: any } = {
    AccountStatusSmartEnum,
    BackgroundTaskStatusSmartEnum,
    CaseMaterialStatusSmartEnum,
    CustomerStatusSmartEnum,
    FoundStatusSmartEnum,
    OperatorStatusSmartEnum,
    OuterCubeStatusSmartEnum,
    PackingBoxStatusSmartEnum,
    RangeStatusSmartEnum,
    RecallLineItemStatusSmartEnum,
    RecallStatusSmartEnum,
    SpecimenStatusSmartEnum,
    UserStatusSmartEnum,
    UpliftStatusSmartEnum,
    ReturnsStatusSmartEnum,
    ReturnLineItemStatusSmartEnum,
    InvoiceTypeSmartEnum,
    OuterCubeTypeSmartEnum,
    UserPermissionsLevelSmartEnum,
    OperatorPermissionsLevelSmartEnum,
    DisposalStatusSmartEnum,
    DisposalLineItemStatusSmartEnum,
    OrderNumberTypeSmartEnum
    // Add other status classes as needed...
};

export function getStatus(obj: StatusDto | IPillLookup | undefined): Status | undefined {
    if(!obj) {
        return undefined;
    }
    if (isStatusDto(obj)) {
        return getStatusByValue(obj?.value, obj?.typeName);
    } else {
        return getStatusByKey(obj.statusKey, obj.statusName)
    }
}

export function getStatusByValue(value: number, typeName: string): Status | undefined {
    const statusClass = statusLookup[typeName];

    if (!statusClass) {
        return undefined; // Return undefined if the status class doesn't exist
    }

    const statuses = Object.values(statusClass) as Status[];
    return statuses.find((status: Status) => status.value === value);
}

export function getStatusByKey(key: string, typeName: string): Status | undefined {
    const statusClass = statusLookup[typeName];

    if (!statusClass) {
        return undefined; // Return undefined if the status class doesn't exist
    }

    const statuses = Object.values(statusClass) as Status[];
    return statuses.find((status: Status) => status.displayValue === key || status.apiKey === key);
}